// routes/Onboarding.jsx — 사람 Node 선언.
//
// 온보딩은 일반 명령이 아니다. `x-loom-node-id` 헤더가 **없는 유일한 쓰기**이고,
// `human_direct` provenance 에서만 통과한다(브릿지 세션은 403).

import { useRef, useState } from 'preact/hooks';
import { onboardHumanNode } from '../api/client.js';
import { useCommand } from '../api/resource.js';
import { describeError } from '../api/errors.js';
import { Button, Field, Form, Input, Notice } from '../ui/primitives.jsx';

export function Onboarding({ onDone }) {
  const nameRef = useRef(null);
  const [validationError, setValidationError] = useState(null);
  const declare = useCommand(
    (name, idempotencyKey) => onboardHumanNode(name, { idempotencyKey }),
    { invalidates: ['entry'] },
  );

  return (
    <main class="plain">
      <div class="plain__inner plain__inner--reading">
        <header class="plain__head">
          <h1 class="t-display">먼저 이름을 정합니다</h1>
          <p class="t-meta prose">
            공동망에서 당신이 말할 자리를 하나 만듭니다. 이 이름은 함께 일하는 사람들에게 보이는
            이름이고, 나중에 바꿀 수 있습니다.
          </p>
        </header>

        {/*
          진짜 <form> 이다. 그래서 Enter 로도 제출되고, 첫 클릭이 삼켜지지 않는다.
          이것이 QA v2 의 D-1 이 재발할 수 없는 이유다.
        */}
        <Form busy={declare.pending} onSubmit={async () => {
          const displayName = nameRef.current?.value?.trim() ?? '';
          if (!displayName) {
            setValidationError('이름을 입력해 주세요.');
            return;
          }
          if (displayName.length > 200) {
            setValidationError('200자를 넘을 수 없습니다.');
            return;
          }
          setValidationError(null);
          const result = await declare.run(displayName);
          if (result.ok) onDone?.();
        }}>
          <div class="stack">
            <Field
              label="이름"
              htmlFor="displayName"
              required
              hint="1~200자."
              error={validationError}
            >
              <Input
                id="displayName"
                name="displayName"
                ref={nameRef}
                invalid={Boolean(validationError)}
                autocomplete="nickname"
                autoFocus
              />
            </Field>

            {declare.error ? (
              <Notice tone="danger" title={describeError(declare.error).message} />
            ) : null}

            <div class="row">
              <Button
                kind="submit"
                tone="human"
                busy={declare.pending}
              >
                {declare.pending ? '만드는 중' : '이 이름으로 시작'}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </main>
  );
}
